  import React, { useState } from 'react';
  import { Form, Input, Select, DatePicker, Button } from 'antd';
  import propTypes from 'prop-types';
  import { DataService } from '../../../config/dataService/dataService';
  import notifyUser from '../../../components/notifications';

  const { Option } = Select;

  const AdministratorForm = ({ onCancel, callback }) => {
    const [form] = Form.useForm();
    const [reason, setReason] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleFileChange = (e) => {
      const file = e.target.files[0];
      if (file) setSelectedFile(file);
    };

    const handleRemoveFile = () => setSelectedFile(null);


    const uploadFileToSpace = async (file) => {
    const preSignedRes = await DataService.post('/v1/pre-signed-url', {
      fileName: file.name,
    });
    
    const { signedUrl, url } = preSignedRes?.data?.data;
    
    if (!signedUrl) {
      throw new Error('Signed URL generated nahi ho paya.');
    }

    const response = await fetch(signedUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
        'x-amz-acl': 'public-read',
      },
      body: file,
    });

    if(!response.ok){
      throw new Error('DigitalOcean par file upload fail ho gaya.');
    }
    return url;
  };

    const handleSubmit = async (values) => {
      setLoading(true);
      try {
        let attachmentUrl = '';

        if (selectedFile) {
          attachmentUrl = await uploadFileToSpace(selectedFile);
        }
        
        console.log ("file", attachmentUrl)

        const payload = {
          name: values.name,
          employeeId: values.employeeId,
          leaveType: values.leaveType,
          fromDate: values.fromDate ? values.fromDate.format('YYYY-MM-DD') : '',
          toDate: values.toDate ? values.toDate.format('YYYY-MM-DD') : '',
          reason: reason,
          attachment: attachmentUrl,
        };

        const response = await DataService.post('/leave-application', payload);

        if (response?.status === 200) {
          notifyUser('success', 'Leave application submitted successfully!', 'Success');
          form.resetFields();
          setReason('');
          setSelectedFile(null);
          if (onCancel) onCancel();
          if (callback) callback();
        }
      } catch (error) {
        console.error('Error submitting leave application:', error);
        const errMsg = error?.response?.data?.message || 'Failed to submit application';
        notifyUser('error', errMsg, 'Error');
      } finally {
        setLoading(false);
      }
    };

    return (
      <div className="leave-form-container">
        <h3 className="leave-form-title">
          Submit your leave application to the CRM Administrator. Approval will be notified via Email.
        </h3>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <div className="form-row two-col" style={{ display: 'flex', gap: '15px' }}>
            <Form.Item
              label="Employee Name"
              name="name"
              style={{ flex: 1 }}
              rules={[{ required: true, message: 'Please enter employee name' }]}
            >
              <Input className="custom-input" placeholder="Enter Full Name" style={{ padding: '8px' }} />
            </Form.Item>

            <Form.Item
              label="Employee ID"
              name="employeeId"
              style={{ flex: 1 }}
              rules={[{ required: true, message: 'Please enter employee ID' }]}
            >
              <Input className="custom-input" placeholder="Enter Employee ID" style={{ padding: '8px' }} />
            </Form.Item>
          </div>

          <Form.Item
            label="Leave Type"
            name="leaveType"
            rules={[{ required: true, message: 'Please select leave type' }]}
          >
            <Select placeholder="Select Leave Type" className="custom-select">
              <Option value="Casual Leave">Casual Leave</Option>
              <Option value="Sick Leave">Sick Leave</Option>
              <Option value="Earned Leave">Earned Leave</Option>
            </Select>
          </Form.Item>

          <div className="form-row two-col" style={{ display: 'flex', gap: '15px' }}>
            <Form.Item
              label="From Date"
              name="fromDate"
              style={{ flex: 1 }}
              rules={[{ required: true, message: 'Select start date' }]}
            >
              <DatePicker className="custom-datepicker" style={{ width: '100%' }} format="DD/MM/YYYY" />
            </Form.Item>

            <Form.Item
              label="To Date"
              name="toDate"
              style={{ flex: 1 }}
              rules={[{ required: true, message: 'Select end date' }]}
            >
              <DatePicker className="custom-datepicker" style={{ width: '100%' }} format="DD/MM/YYYY" />
            </Form.Item>
          </div>

          <Form.Item
            label="Leave reason"
            name="reason"
            rules={[{ required: true, message: 'Please input leave reason' }]}
          >
            <div className="field-group compact textarea-group">
              <div className="textarea-shell relative-position">
                <textarea
                  id="leave-reason"
                  name="leave Reason"
                  maxLength={500}
                  placeholder="Please describe the reason for your leave..."
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                  className="textarea-with-action-bar"
                  rows={4}
                  style={{ width: '100%', padding: '10px', borderRadius: '4px' }}
                />

                <div
                  className="textarea-action-bar"
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginTop: '8px',
                  }}
                >
                  <div
                    className="file-upload-wrapper"
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                  >
                    <input
                      type="file"
                      id="file-attachment"
                      accept=".pdf,.docx,.xlsx,.xls,.txt,.jpg,.jpeg,.png,.webp"
                      className="hidden-file-input"
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                    <label
                      htmlFor="file-attachment"
                      title="Attach a file"
                      className="add-file-btn"
                      style={{
                        cursor: 'pointer',
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                    </label>

                    {selectedFile && (
                      <span
                        className="selected-file-badge"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px',
                          background: '#f0f0f0',
                          padding: '2px 8px',
                          borderRadius: '4px',
                        }}
                      >
                        <span className="file-name-text" title={selectedFile.name}>
                          {selectedFile.name}
                        </span>
                        <button
                          type="button"
                          onClick={handleRemoveFile}
                          className="remove-file-btn"
                          title="Remove file"
                          style={{
                            background: 'none',
                            border: 'none',
                            cursor: 'pointer',
                            padding: 0,
                          }}
                        >
                          <svg
                            width="10"
                            height="10"
                            viewBox="0 0 14 14"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                          >
                            <path d="M1 1l12 12M13 1L1 13" />
                          </svg>
                        </button>
                      </span>
                    )}
                  </div>

                  <span
                    id="character-count"
                    className="character-count text-count"
                    style={{ fontSize: '12px', color: '#8c8c8c' }}
                  >
                    {reason.length} / 500
                  </span>
                </div>
              </div>
            </div>
          </Form.Item>

          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}
            >
              <span>Submit to CRM Administrator</span>
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  };

  AdministratorForm.propTypes = {
    onCancel: propTypes.func,
    callback: propTypes.func,
  };

  export default AdministratorForm;